import { useEffect } from "react";

const TurnstileLoader = ({ siteKey, onSuccess }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);

    script.onload = () => {
      if (window.turnstile) {
        window.turnstile.render("#turnstile-container", {
          sitekey: siteKey,
          callback: token => onSuccess(token),
          "expired-callback": () => onSuccess(""),
          "error-callback": () => onSuccess("")
        });
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, [siteKey, onSuccess]);

  return <div id="turnstile-container"></div>;
};

export default TurnstileLoader;
